import { render, staticRenderFns } from "./SalaryRange.vue?vue&type=template&id=b84877ce&scoped=true"
import script from "./SalaryRange.vue?vue&type=script&lang=js"
export * from "./SalaryRange.vue?vue&type=script&lang=js"
import style0 from "./SalaryRange.vue?vue&type=style&index=0&id=b84877ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84877ce",
  null
  
)

export default component.exports